/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Occupancy_No_PassengersInputs */

const fr_marker_occupancy_no_passengers = /** @type {(inputs: Marker_Occupancy_No_PassengersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne prend pas de voyageur`)
};

const en_marker_occupancy_no_passengers = /** @type {(inputs: Marker_Occupancy_No_PassengersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not taking passengers`)
};

/**
* | output |
* | --- |
* | "Not taking passengers" |
*
* @param {Marker_Occupancy_No_PassengersInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_occupancy_no_passengers = /** @type {((inputs?: Marker_Occupancy_No_PassengersInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Occupancy_No_PassengersInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_occupancy_no_passengers(inputs)
	return en_marker_occupancy_no_passengers(inputs)
});